
<div class="modal-header">
    <h4 class="modal-title pull-left">Reject</h4>
    <button type="button" class="close" aria-label="Close" (click)="bsModalRef?.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <section class="prInitiator">
        <div class="d-flex flex-column mb-4 mt-1">
            <ng-container>
                <form [formGroup]="statusForm" class="p-4">
                    <div class="row">
                        <label for="remarks" class="form-label text-large">Remarks</label>
                        <textarea formControlName="remarks" class="form-control" [(ngModel)]="remarks"></textarea>
                        <form-feedback [formGroup]="statusForm" field="remarks"></form-feedback>
                    </div>
                </form>
            </ng-container>            
        </div>
    </section>
</div>
<div class="modal-footer">
    <ng-container>
        <button type="button" class="btn btn-primary me-2 align-self-center text-white" (click)="approveRejectPR()">Reject</button>
    </ng-container>
</div>